import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M10 18a.97.97 0 0 1-.712-.288A.97.97 0 0 1 9 17q0-.424.288-.712A.97.97 0 0 1 10 16h10q.425 0 .713.288T21 17q0 .424-.288.713A.96.96 0 0 1 20 18zm0-5a.97.97 0 0 1-.712-.288A.97.97 0 0 1 9 12q0-.424.288-.712A.97.97 0 0 1 10 11h10q.425 0 .713.288T21 12q0 .424-.288.713A.96.96 0 0 1 20 13zM4 8a.97.97 0 0 1-.712-.288A.97.97 0 0 1 3 7q0-.424.288-.712A.97.97 0 0 1 4 6h16q.425 0 .713.288.288.289.287.712 0 .424-.288.713A.96.96 0 0 1 20 8z"
    }, null, -1)
  ]))]))
}
export default { render: render }